import { useState, useEffect } from "react";
import axios from "axios";

// ── FAO-56 crop database (98 crops) ──────────────────────────────────────────
// kc: [ini, mid, late]  L: [Lini, Ldev, Lmid, Llate] in days
// plantMonthN: typical N-hemisphere planting month (1=Jan)
export const IRRIG_CROPS = {
  // ── Vegetables ──
  artichoke:        { name:"Artichoke",              kc:[0.50,1.00,0.95], L:[40,40,250,30],  plantMonthN:3,  cat:"Vegetable" },
  asparagus:        { name:"Asparagus",              kc:[0.50,0.95,0.30], L:[50,90,100,50],  plantMonthN:3,  cat:"Vegetable" },
  beet_table:       { name:"Beet (table)",           kc:[0.50,1.05,0.95], L:[25,30,25,10],   plantMonthN:3,  cat:"Vegetable" },
  broccoli:         { name:"Broccoli",               kc:[0.70,1.05,0.95], L:[35,45,40,15],   plantMonthN:8,  cat:"Vegetable" },
  brussels_sprouts: { name:"Brussels Sprouts",       kc:[0.70,1.05,0.95], L:[30,35,90,40],   plantMonthN:5,  cat:"Vegetable" },
  cabbage:          { name:"Cabbage",                kc:[0.70,1.05,0.95], L:[40,60,50,15],   plantMonthN:3,  cat:"Vegetable" },
  cantaloupe:       { name:"Cantaloupe",             kc:[0.50,0.85,0.60], L:[30,45,35,10],   plantMonthN:4,  cat:"Vegetable" },
  carrot:           { name:"Carrot",                 kc:[0.70,1.05,0.95], L:[30,40,60,20],   plantMonthN:3,  cat:"Vegetable" },
  cauliflower:      { name:"Cauliflower",            kc:[0.70,1.05,0.95], L:[35,50,40,15],   plantMonthN:8,  cat:"Vegetable" },
  celery:           { name:"Celery",                 kc:[0.70,1.05,1.00], L:[25,40,95,20],   plantMonthN:4,  cat:"Vegetable" },
  cucumber:         { name:"Cucumber",               kc:[0.60,1.00,0.75], L:[20,30,40,15],   plantMonthN:5,  cat:"Vegetable" },
  eggplant:         { name:"Eggplant",               kc:[0.60,1.05,0.90], L:[30,40,40,20],   plantMonthN:4,  cat:"Vegetable" },
  garlic:           { name:"Garlic",                 kc:[0.70,1.00,0.70], L:[25,25,30,20],   plantMonthN:10, cat:"Vegetable" },
  kale:             { name:"Kale",                   kc:[0.70,1.05,0.95], L:[30,35,40,25],   plantMonthN:8,  cat:"Vegetable" },
  leek:             { name:"Leek",                   kc:[0.70,1.10,1.05], L:[25,75,70,30],   plantMonthN:3,  cat:"Vegetable" },
  lettuce:          { name:"Lettuce",                kc:[0.70,1.00,0.95], L:[20,30,15,10],   plantMonthN:2,  cat:"Vegetable" },
  okra:             { name:"Okra",                   kc:[0.60,0.95,0.80], L:[20,30,40,20],   plantMonthN:5,  cat:"Vegetable" },
  onion_dry:        { name:"Onion (dry)",            kc:[0.70,1.05,0.75], L:[15,25,70,40],   plantMonthN:3,  cat:"Vegetable" },
  onion_green:      { name:"Onion (green)",          kc:[0.70,1.00,1.00], L:[25,30,10,5],    plantMonthN:3,  cat:"Vegetable" },
  peas_fresh:       { name:"Peas (fresh)",           kc:[0.60,1.15,1.10], L:[15,25,35,15],   plantMonthN:3,  cat:"Vegetable" },
  pepper:           { name:"Sweet Pepper",           kc:[0.60,1.05,0.90], L:[30,40,110,30],  plantMonthN:4,  cat:"Vegetable" },
  pumpkin:          { name:"Pumpkin / Winter Squash",kc:[0.50,1.00,0.80], L:[20,30,30,20],   plantMonthN:5,  cat:"Vegetable" },
  radish:           { name:"Radish",                 kc:[0.70,0.90,0.85], L:[5,10,15,5],     plantMonthN:3,  cat:"Vegetable" },
  spinach:          { name:"Spinach",                kc:[0.70,1.00,0.95], L:[20,20,15,5],    plantMonthN:3,  cat:"Vegetable" },
  squash:           { name:"Squash (summer/zucchini)",kc:[0.50,0.90,0.75],L:[20,30,25,15],  plantMonthN:5,  cat:"Vegetable" },
  sweet_corn:       { name:"Sweet Corn",             kc:[0.30,1.20,1.05], L:[20,25,25,10],   plantMonthN:4,  cat:"Vegetable" },
  swiss_chard:      { name:"Swiss Chard",            kc:[0.70,1.05,1.00], L:[25,30,25,10],   plantMonthN:3,  cat:"Vegetable" },
  tomato_fresh:     { name:"Tomato (fresh)",         kc:[0.60,1.15,0.80], L:[30,40,40,25],   plantMonthN:4,  cat:"Vegetable" },
  tomato_proc:      { name:"Tomato (processing)",    kc:[0.60,1.15,0.80], L:[30,40,45,30],   plantMonthN:4,  cat:"Vegetable" },
  turnip:           { name:"Turnip",                 kc:[0.50,1.10,0.95], L:[25,30,35,10],   plantMonthN:8,  cat:"Vegetable" },
  watermelon:       { name:"Watermelon",             kc:[0.40,1.00,0.75], L:[20,30,30,30],   plantMonthN:5,  cat:"Vegetable" },
  // ── Root / Tubers ──
  cassava:          { name:"Cassava",                kc:[0.30,0.80,0.50], L:[60,90,120,60],  plantMonthN:4,  cat:"Root/Tuber" },
  potato:           { name:"Potato",                 kc:[0.50,1.15,0.75], L:[25,30,45,30],   plantMonthN:3,  cat:"Root/Tuber" },
  sweet_potato:     { name:"Sweet Potato",           kc:[0.50,1.15,0.65], L:[20,30,60,40],   plantMonthN:4,  cat:"Root/Tuber" },
  yam:              { name:"Yam",                    kc:[0.50,1.00,0.75], L:[25,60,120,45],  plantMonthN:4,  cat:"Root/Tuber" },
  // ── Legumes ──
  bean_dry:         { name:"Bean (dry)",             kc:[0.40,1.15,0.35], L:[20,30,40,20],   plantMonthN:5,  cat:"Legume" },
  bean_green:       { name:"Bean (green/snap)",      kc:[0.40,1.05,0.90], L:[20,30,30,10],   plantMonthN:4,  cat:"Legume" },
  chickpea:         { name:"Chickpea",               kc:[0.40,1.00,0.35], L:[20,35,45,25],   plantMonthN:10, cat:"Legume" },
  cowpea:           { name:"Cowpea",                 kc:[0.40,1.05,0.50], L:[20,35,45,25],   plantMonthN:5,  cat:"Legume" },
  fava_bean:        { name:"Fava Bean",              kc:[0.50,1.15,1.10], L:[90,45,40,0],    plantMonthN:10, cat:"Legume" },
  groundnut:        { name:"Groundnut / Peanut",     kc:[0.40,1.15,0.60], L:[35,35,35,35],   plantMonthN:5,  cat:"Legume" },
  lentil:           { name:"Lentil",                 kc:[0.40,1.10,0.30], L:[25,35,70,40],   plantMonthN:10, cat:"Legume" },
  soybean:          { name:"Soybean",                kc:[0.40,1.15,0.50], L:[20,30,60,25],   plantMonthN:5,  cat:"Legume" },
  // ── Cereals ──
  barley:           { name:"Barley",                 kc:[0.30,1.15,0.25], L:[30,60,40,20],   plantMonthN:10, cat:"Cereal" },
  corn_maize:       { name:"Corn / Maize",           kc:[0.30,1.20,0.60], L:[25,40,45,15],   plantMonthN:4,  cat:"Cereal" },
  millet:           { name:"Millet",                 kc:[0.30,1.00,0.30], L:[15,25,40,25],   plantMonthN:6,  cat:"Cereal" },
  oat:              { name:"Oat",                    kc:[0.30,1.15,0.25], L:[25,50,60,30],   plantMonthN:3,  cat:"Cereal" },
  quinoa:           { name:"Quinoa",                 kc:[0.52,1.00,0.56], L:[30,50,40,30],   plantMonthN:4,  cat:"Cereal" },
  rice:             { name:"Rice (paddy)",           kc:[1.05,1.20,1.05], L:[30,30,60,30],   plantMonthN:6,  cat:"Cereal" },
  rye:              { name:"Rye",                    kc:[0.30,1.15,0.25], L:[30,65,40,30],   plantMonthN:10, cat:"Cereal" },
  sorghum:          { name:"Sorghum",                kc:[0.30,1.00,0.55], L:[20,35,40,30],   plantMonthN:5,  cat:"Cereal" },
  wheat_winter:     { name:"Wheat (winter)",         kc:[0.40,1.15,0.40], L:[30,140,40,30],  plantMonthN:10, cat:"Cereal" },
  wheat_spring:     { name:"Wheat (spring)",         kc:[0.30,1.15,0.25], L:[30,40,60,40],   plantMonthN:3,  cat:"Cereal" },
  // ── Oil Crops ──
  canola:           { name:"Canola / Rapeseed",      kc:[0.35,1.15,0.35], L:[35,65,50,40],   plantMonthN:9,  cat:"Oil Crop" },
  cotton:           { name:"Cotton",                 kc:[0.45,1.20,0.60], L:[30,50,60,55],   plantMonthN:4,  cat:"Oil Crop" },
  flax:             { name:"Flax / Linseed",         kc:[0.40,1.10,0.25], L:[25,35,50,40],   plantMonthN:3,  cat:"Oil Crop" },
  safflower:        { name:"Safflower",              kc:[0.35,1.10,0.25], L:[20,35,55,30],   plantMonthN:3,  cat:"Oil Crop" },
  sesame:           { name:"Sesame",                 kc:[0.35,1.10,0.25], L:[20,30,40,20],   plantMonthN:5,  cat:"Oil Crop" },
  sunflower:        { name:"Sunflower",              kc:[0.35,1.10,0.35], L:[25,35,45,25],   plantMonthN:5,  cat:"Oil Crop" },
  // ── Sugar ──
  sugarcane:        { name:"Sugarcane",              kc:[0.40,1.25,0.75], L:[35,60,190,120], plantMonthN:1,  cat:"Sugar" },
  sugar_beet:       { name:"Sugar Beet",             kc:[0.35,1.20,0.70], L:[35,60,70,40],   plantMonthN:3,  cat:"Sugar" },
  // ── Tropical Fruits ──
  avocado:          { name:"Avocado",                kc:[0.60,0.85,0.75], L:[60,90,120,60],  plantMonthN:1,  cat:"Tropical Fruit" },
  banana:           { name:"Banana",                 kc:[0.50,1.10,1.00], L:[120,60,180,5],  plantMonthN:1,  cat:"Tropical Fruit" },
  citrus_orange:    { name:"Citrus (orange)",        kc:[0.70,0.90,0.75], L:[60,90,120,95],  plantMonthN:1,  cat:"Tropical Fruit" },
  citrus_lemon:     { name:"Citrus (lemon/lime)",    kc:[0.70,0.90,0.75], L:[60,90,120,95],  plantMonthN:1,  cat:"Tropical Fruit" },
  coconut:          { name:"Coconut",                kc:[0.90,1.00,1.00], L:[180,180,180,180],plantMonthN:1, cat:"Tropical Fruit" },
  coffee:           { name:"Coffee",                 kc:[0.90,1.05,1.05], L:[90,90,90,90],   plantMonthN:1,  cat:"Tropical Crop" },
  mango:            { name:"Mango",                  kc:[0.60,1.05,0.75], L:[30,50,30,10],   plantMonthN:10, cat:"Tropical Fruit" },
  papaya:           { name:"Papaya",                 kc:[0.60,1.05,0.90], L:[60,60,180,60],  plantMonthN:1,  cat:"Tropical Fruit" },
  pineapple:        { name:"Pineapple",              kc:[0.50,0.30,0.30], L:[60,120,240,10], plantMonthN:1,  cat:"Tropical Fruit" },
  tea:              { name:"Tea",                    kc:[0.90,1.00,1.00], L:[180,180,180,180],plantMonthN:1, cat:"Tropical Crop" },
  // ── Deciduous Fruits / Nuts ──
  almond:           { name:"Almond",                 kc:[0.40,1.05,0.65], L:[20,70,80,30],   plantMonthN:3,  cat:"Tree Nut" },
  apple:            { name:"Apple",                  kc:[0.45,1.20,0.85], L:[20,70,90,30],   plantMonthN:3,  cat:"Deciduous Fruit" },
  apricot:          { name:"Apricot",                kc:[0.45,1.05,0.65], L:[20,70,90,30],   plantMonthN:3,  cat:"Deciduous Fruit" },
  cherry:           { name:"Cherry",                 kc:[0.45,1.10,0.75], L:[20,70,90,30],   plantMonthN:3,  cat:"Deciduous Fruit" },
  olive:            { name:"Olive",                  kc:[0.65,0.70,0.70], L:[30,90,60,90],   plantMonthN:3,  cat:"Tree Nut/Oil" },
  peach:            { name:"Peach / Nectarine",      kc:[0.45,1.20,0.85], L:[20,70,90,30],   plantMonthN:3,  cat:"Deciduous Fruit" },
  pear:             { name:"Pear",                   kc:[0.45,1.20,0.85], L:[20,60,90,45],   plantMonthN:3,  cat:"Deciduous Fruit" },
  pistachio:        { name:"Pistachio",              kc:[0.40,1.10,0.45], L:[20,60,70,30],   plantMonthN:3,  cat:"Tree Nut" },
  plum:             { name:"Plum / Prune",           kc:[0.45,1.15,0.80], L:[20,70,90,30],   plantMonthN:3,  cat:"Deciduous Fruit" },
  walnut:           { name:"Walnut",                 kc:[0.50,1.10,0.65], L:[20,70,90,30],   plantMonthN:3,  cat:"Tree Nut" },
  // ── Berries / Vines ──
  blueberry:        { name:"Blueberry",              kc:[0.30,0.90,0.75], L:[30,60,90,30],   plantMonthN:4,  cat:"Berry" },
  grape_table:      { name:"Grape (table)",          kc:[0.30,0.90,0.45], L:[20,40,120,60],  plantMonthN:4,  cat:"Vine" },
  grape_wine:       { name:"Grape (wine)",           kc:[0.30,0.85,0.45], L:[20,40,120,60],  plantMonthN:4,  cat:"Vine" },
  raspberry:        { name:"Raspberry",              kc:[0.30,1.05,0.85], L:[20,50,50,20],   plantMonthN:4,  cat:"Berry" },
  strawberry:       { name:"Strawberry",             kc:[0.40,0.85,0.75], L:[40,30,60,20],   plantMonthN:3,  cat:"Berry" },
  // ── Forages ──
  alfalfa:          { name:"Alfalfa (multi-cut)",    kc:[0.40,1.20,1.15], L:[10,30,15,10],   plantMonthN:3,  cat:"Forage" },
  bermuda_grass:    { name:"Bermuda Grass",          kc:[0.60,1.05,0.85], L:[10,30,120,60],  plantMonthN:4,  cat:"Forage" },
  clover:           { name:"Clover",                 kc:[0.40,1.15,1.05], L:[10,30,120,60],  plantMonthN:3,  cat:"Forage" },
  ryegrass:         { name:"Ryegrass / Pasture",     kc:[0.95,1.05,1.00], L:[10,20,150,50],  plantMonthN:9,  cat:"Forage" },
  // ── Specialty / Herbs ──
  basil:            { name:"Basil",                  kc:[0.40,1.05,0.75], L:[25,30,40,20],   plantMonthN:4,  cat:"Herb" },
  cilantro:         { name:"Cilantro / Coriander",   kc:[0.40,0.95,0.85], L:[20,25,15,5],    plantMonthN:3,  cat:"Herb" },
  hemp:             { name:"Hemp / Cannabis",         kc:[0.40,1.05,0.70], L:[30,45,45,30],   plantMonthN:5,  cat:"Specialty" },
  hops:             { name:"Hops",                   kc:[0.30,1.05,0.85], L:[25,45,70,30],   plantMonthN:4,  cat:"Specialty" },
  mint:             { name:"Mint",                   kc:[0.60,1.15,1.10], L:[25,30,100,35],  plantMonthN:4,  cat:"Herb" },
  tobacco:          { name:"Tobacco",                kc:[0.30,1.10,1.05], L:[30,45,45,30],   plantMonthN:4,  cat:"Specialty" },
};

const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const MONTH_ABBRS = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
const MONTH_DAYS  = [31,28,31,30,31,30,31,31,30,31,30,31];

const SCENARIOS = [
  { key:"bau",    name:"Current",  dTemp:0,   dPrecip:0.00, etoMult:1.000, color:"#888" },
  { key:"ssp126", name:"SSP1-2.6", dTemp:1.5, dPrecip:0.05, etoMult:1.030, color:"#4CAF50" },
  { key:"ssp245", name:"SSP2-4.5", dTemp:2.0, dPrecip:-0.05,etoMult:1.040, color:"#FF9800" },
  { key:"ssp370", name:"SSP3-7.0", dTemp:3.0, dPrecip:-0.10,etoMult:1.060, color:"#E53935" },
  { key:"ssp585", name:"SSP5-8.5", dTemp:4.5, dPrecip:-0.15,etoMult:1.090, color:"#7B1FA2" },
];

const CAT_ORDER = ["Vegetable","Root/Tuber","Legume","Cereal","Oil Crop","Sugar",
                   "Tropical Fruit","Tropical Crop","Deciduous Fruit","Tree Nut",
                   "Tree Nut/Oil","Berry","Vine","Forage","Herb","Specialty"];

function kcAtDay(crop, day) {
  const [Lini, Ldev, Lmid, Llate] = crop.L;
  const [kcIni, kcMid, kcEnd] = crop.kc;
  if (day <= Lini) return kcIni;
  if (day <= Lini + Ldev) return kcIni + ((day - Lini) / Ldev) * (kcMid - kcIni);
  if (day <= Lini + Ldev + Lmid) return kcMid;
  const frac = Math.min((day - Lini - Ldev - Lmid) / Math.max(Llate, 1), 1);
  return kcMid + frac * (kcEnd - kcMid);
}

function calcMonthly(crop, climate, plantMonth0, etoMult, precipMult) {
  const totalDays = crop.L.reduce((a, b) => a + b, 0);
  const results = [];
  let dayStart = 0;
  let mo = plantMonth0;
  while (dayStart < totalDays) {
    const nDays = MONTH_DAYS[mo % 12];
    const dayEnd = Math.min(dayStart + nDays, totalDays);
    const midDay = (dayStart + dayEnd) / 2;
    const kc = kcAtDay(crop, midDay);
    const calMo = mo % 12;
    const eto = (climate.eto[calMo] || 0) * etoMult;
    const precip = (climate.precip[calMo] || 0) * precipMult;
    const eta = eto * kc;
    const blue = Math.max(0, eta - precip);
    const green = Math.min(eta, precip);
    results.push({ mo: calMo, name: MONTH_NAMES[calMo], kc: +kc.toFixed(2), eta: +eta.toFixed(2), blue: +blue.toFixed(2), green: +green.toFixed(2) });
    dayStart += nDays;
    mo++;
    if (mo - plantMonth0 > 24) break;
  }
  return results;
}

function convert(acreIn, unit, perArea = false) {
  if (perArea) return { val: (acreIn * 25.4).toFixed(1), label: "mm" };
  switch (unit) {
    case "acre-in": return { val: acreIn.toFixed(1),              label: "ac·in" };
    case "acre-ft": return { val: (acreIn / 12).toFixed(2),       label: "ac·ft" };
    case "m3":      return { val: (acreIn * 102.79).toFixed(0),   label: "m³" };
    case "mm":      return { val: (acreIn * 25.4).toFixed(1),     label: "mm" };
    case "gal":     return { val: (acreIn * 27154 / 1000).toFixed(1), label: "k·gal" };
    default:        return { val: acreIn.toFixed(1),              label: "ac·in" };
  }
}

function MonthlyChart({ months, acreage }) {
  if (!months.length) return null;
  const W = 300, H = 140, PAD = { t: 10, b: 32, l: 38, r: 10 };
  const iW = W - PAD.l - PAD.r;
  const iH = H - PAD.t - PAD.b;
  const n = months.length;
  const etaVals   = months.map(m => m.eta);
  const maxVal    = Math.max(...etaVals, 0.1);
  const xOf = i => PAD.l + (i / (n - 1 || 1)) * iW;
  const yOf = v => PAD.t + iH - (v / maxVal) * iH;
  const etaPts   = months.map((m, i) => `${xOf(i)},${yOf(m.eta)}`).join(" ");
  const greenPts = months.map((m, i) => `${xOf(i)},${yOf(m.green)}`).join(" ");
  const blueFill = [
    ...months.map((m, i) => `${xOf(i)},${yOf(m.eta)}`),
    ...[...months].reverse().map((m, i) => `${xOf(n - 1 - i)},${yOf(m.green)}`),
  ].join(" ");
  const greenFill = [
    ...months.map((m, i) => `${xOf(i)},${yOf(m.green)}`),
    `${xOf(n - 1)},${yOf(0)}`, `${xOf(0)},${yOf(0)}`,
  ].join(" ");
  const yTicks = [0, 0.25, 0.5, 0.75, 1];
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", height: H }}>
      {yTicks.map(f => {
        const y = PAD.t + iH * (1 - f);
        return <g key={f}>
          <line x1={PAD.l} y1={y} x2={PAD.l + iW} y2={y} stroke="rgba(0,0,0,0.06)" strokeWidth={1} />
          <text x={PAD.l - 3} y={y + 3} fontSize={7} fill="#bbb" textAnchor="end">{(maxVal * f).toFixed(1)}</text>
        </g>;
      })}
      <polygon points={greenFill} fill="rgba(74,158,47,0.18)" />
      <polygon points={blueFill} fill="rgba(19,86,168,0.15)" />
      <polyline points={greenPts} fill="none" stroke="rgba(74,158,47,0.9)" strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
      <polyline points={etaPts} fill="none" stroke="rgba(19,86,168,0.9)" strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
      {months.map((m, i) => (
        <g key={i}>
          <circle cx={xOf(i)} cy={yOf(m.eta)}   r={2.5} fill="rgba(19,86,168,0.9)" />
          <circle cx={xOf(i)} cy={yOf(m.green)} r={2.5} fill="rgba(74,158,47,0.9)" />
          <text x={xOf(i)} y={H - PAD.b + 11} fontSize={7.5} fill="#777" textAnchor="middle">{m.name}</text>
        </g>
      ))}
      <text x={10} y={PAD.t + iH / 2} fontSize={7} fill="#bbb" textAnchor="middle" transform={`rotate(-90,10,${PAD.t + iH / 2})`}>in/month</text>
      <line x1={PAD.l} y1={H - 9} x2={PAD.l + 14} y2={H - 9} stroke="rgba(19,86,168,0.9)" strokeWidth={2} />
      <text x={PAD.l + 17} y={H - 5} fontSize={7} fill="#555">ETa (total need)</text>
      <line x1={PAD.l + 100} y1={H - 9} x2={PAD.l + 114} y2={H - 9} stroke="rgba(74,158,47,0.9)" strokeWidth={2} />
      <text x={PAD.l + 117} y={H - 5} fontSize={7} fill="#555">Green (rain)</text>
      <rect x={PAD.l + 175} y={H - 13} width={10} height={7} fill="rgba(19,86,168,0.15)" stroke="rgba(19,86,168,0.5)" strokeWidth={0.5} />
      <text x={PAD.l + 188} y={H - 5} fontSize={7} fill="#555">= irrigation</text>
    </svg>
  );
}

// ── Net need cell ────────────────────────────────────────────────────────────
function NetCell({ mm }) {
  const bg = mm <= 0 ? "#f0fdf4" : mm < 20 ? "#fef9c3" : mm < 40 ? "#ffedd5" : "#fee2e2";
  const co = mm <= 0 ? "#15803d" : mm < 20 ? "#854d0e" : mm < 40 ? "#9a3412" : "#991b1b";
  return (
    <td style={{ textAlign:"right", padding:"5px 8px", background:bg, color:co, fontWeight:600, fontSize:11 }}>
      {mm <= 0 ? "None" : `${mm.toFixed(1)} mm`}
    </td>
  );
}

// ── 7-day forecast schedule ──────────────────────────────────────────────────
function ForecastSchedule({ coordinates, cropKcMid, acreHa }) {
  const [forecast, setForecast] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!coordinates || coordinates.length < 3) return;
    const lat = (coordinates.reduce((s, c) => s + c[1], 0) / coordinates.length).toFixed(4);
    const lon = (coordinates.reduce((s, c) => s + c[0], 0) / coordinates.length).toFixed(4);
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}` +
      `&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,weathercode,et0_fao_evapotranspiration` +
      `&forecast_days=7&timezone=auto`;
    fetch(url).then(r => r.json()).then(d => setForecast(d)).catch(() => setErr("Could not load forecast"));
  }, [coordinates]);

  if (err) return <div style={{ color:"#c33", fontSize:12 }}>{err}</div>;
  if (!forecast?.daily) return <div style={{ color:"#7a9a6a", fontSize:12 }}>Loading 7-day forecast…</div>;

  const d = forecast.daily;
  return (
    <div>
      <div style={{ fontSize:11, color:"#7a9a6a", marginBottom:8, lineHeight:1.5 }}>
        Best time to irrigate: <strong>early morning (5–8 AM)</strong> — lower evaporation, better absorption.
        Skip days shown as "No irrigation needed" or "Skip — rain forecast."
      </div>
      <div style={{ overflowX:"auto" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
          <thead>
            <tr style={{ background:"#f0f6ea" }}>
              {["Date","High / Low","Rain","ET0","ETc (Kc={kc})","Net Need","Action"].map((h, hi) => (
                <th key={hi} style={{ padding:"6px 8px", textAlign: hi === 0 ? "left" : "right",
                  fontWeight:700, fontSize:10, color:"#374151", borderBottom:"1px solid #e2ead8",
                  whiteSpace:"nowrap" }}>
                  {h.replace("{kc}", cropKcMid.toFixed(2))}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {d.time.map((dt, i) => {
              const rain  = d.precipitation_sum[i] ?? 0;
              const et0   = d.et0_fao_evapotranspiration?.[i] ?? 0;
              const etc   = +(et0 * cropKcMid).toFixed(1);
              const net   = Math.max(0, +(etc - rain).toFixed(1));
              const m3    = +(net / 1000 * acreHa * 10000).toFixed(0);
              const dateStr = new Date(dt).toLocaleDateString(undefined, { weekday:"short", month:"short", day:"numeric" });
              let action, actColor;
              if (rain > 8) { action = "Skip — sufficient rain"; actColor = "#15803d"; }
              else if (net < 1) { action = "No irrigation needed"; actColor = "#15803d"; }
              else if (net < 4) { action = `Light: ~${net} mm`; actColor = "#854d0e"; }
              else { action = `Irrigate ${net} mm (${m3} m³)`; actColor = "#991b1b"; }
              return (
                <tr key={dt} style={{ borderBottom:"1px solid #f0f0f0" }}>
                  <td style={{ padding:"5px 8px", fontWeight:600, color:"#1a2e1a" }}>{dateStr}</td>
                  <td style={{ padding:"5px 8px", textAlign:"right", color:"#374151" }}>
                    {d.temperature_2m_max[i]?.toFixed(0)}° / {d.temperature_2m_min[i]?.toFixed(0)}°C
                  </td>
                  <td style={{ padding:"5px 8px", textAlign:"right", color: rain > 2 ? "#2563eb" : "#374151" }}>
                    {rain.toFixed(1)} mm
                  </td>
                  <td style={{ padding:"5px 8px", textAlign:"right", color:"#374151" }}>{et0.toFixed(1)} mm</td>
                  <td style={{ padding:"5px 8px", textAlign:"right", color:"#374151" }}>{etc} mm</td>
                  <NetCell mm={net} />
                  <td style={{ padding:"5px 8px", textAlign:"right", color:actColor, fontWeight:600 }}>{action}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ fontSize:10, color:"#aaa", marginTop:6 }}>
        ET0 from Open-Meteo FAO-56 Penman-Monteith. ETc = ET0 × Kc (mid-season). Net = ETc − rainfall.
      </div>
    </div>
  );
}

// ── Rank all crops by irrigation ease for a given climate ────────────────────
// Crop temperature requirements (°C) — mirrors _CROP_REQUIREMENTS in backend
const CROP_TEMP_RANGE = {
  artichoke:[7,29],asparagus:[5,30],"beet_table":[5,25],broccoli:[5,23],"brussels_sprouts":[5,22],
  cabbage:[5,25],cantaloupe:[15,35],carrot:[7,28],cauliflower:[5,22],celery:[10,25],
  cucumber:[15,35],eggplant:[15,35],garlic:[0,28],kale:[5,25],leek:[5,25],lettuce:[5,24],
  okra:[22,38],onion_dry:[10,28],"onion_green":[10,28],"peas_fresh":[5,22],"sweet_pepper":[15,35],
  "pumpkin_winter_squash":[15,35],radish:[5,25],spinach:[5,22],"squash_summer_zucchini":[15,35],
  sweet_corn:[12,35],"swiss_chard":[5,28],"tomato_fresh":[15,35],"tomato_processing":[15,35],
  turnip:[5,25],watermelon:[20,38],cassava:[18,35],potato:[8,25],"sweet_potato":[18,35],yam:[20,35],
  "bean_dry":[15,30],"bean_green_snap":[15,30],chickpea:[10,30],cowpea:[20,40],"fava_bean":[5,25],
  "groundnut_peanut":[20,35],lentil:[7,27],soybean:[15,32],barley:[3,25],"corn_maize":[10,35],
  millet:[20,40],oat:[4,28],quinoa:[5,30],"rice_paddy":[16,38],rye:[0,25],sorghum:[15,38],
  "wheat_winter":[3,28],"wheat_spring":[3,28],"canola_rapeseed":[5,28],cotton:[18,38],
  "flax_linseed":[5,28],safflower:[15,35],sesame:[22,38],sunflower:[15,35],sugarcane:[20,38],
  "sugar_beet":[5,25],avocado:[15,35],banana:[15,38],"citrus_orange":[12,38],
  "citrus_lemon_lime":[12,38],coconut:[20,38],coffee:[15,28],mango:[20,42],papaya:[20,38],
  pineapple:[18,35],tea:[10,28],almond:[12,38],apple:[4,28],apricot:[5,32],cherry:[4,25],
  olive:[10,38],"peach_nectarine":[5,32],pear:[5,28],pistachio:[10,38],"plum_prune":[5,32],
  walnut:[8,32],blueberry:[5,25],"grape_table":[12,35],"grape_wine":[12,35],raspberry:[5,25],
  strawberry:[5,28],"alfalfa_multi_cut":[5,32],"bermuda_grass":[18,38],clover:[5,30],
  "ryegrass_pasture":[5,28],basil:[18,35],"cilantro_coriander":[7,28],"hemp_cannabis":[10,32],
  hops:[5,22],mint:[7,28],tobacco:[18,35],
};

function cropTempOk(key, annAvgTempC) {
  if (annAvgTempC == null) return true;
  const r = CROP_TEMP_RANGE[key];
  if (!r) return true;
  return annAvgTempC >= r[0] && annAvgTempC <= r[1];
}

function rankCropsByLocation(climate, plantMonth0, excludeKey) {
  const annTemp = climate?.ann_temp_c;
  return Object.entries(IRRIG_CROPS)
    .filter(([k]) => k !== excludeKey)
    .map(([key, crop]) => {
      const months   = calcMonthly(crop, climate, plantMonth0, 1, 1);
      const blue     = months.reduce((s, m) => s + m.blue,  0);
      const eta      = months.reduce((s, m) => s + m.eta,   0);
      const green    = months.reduce((s, m) => s + m.green, 0);
      const rainPct  = eta > 0 ? green / eta * 100 : 0;
      const tempOk   = cropTempOk(key, annTemp);
      return { key, crop, blue, eta, green, rainPct, tempOk };
    })
    .filter(c => c.tempOk)  // exclude crops that can't grow at this temperature
    .sort((a, b) => a.blue - b.blue || b.rainPct - a.rainPct);
}

function irrigLabel(blue, eta) {
  if (eta === 0) return { label:"No data", color:"#6b7280" };
  const pct = blue / eta * 100;
  if (pct < 5)  return { label:"Rainfed",     color:"#15803d" };
  if (pct < 25) return { label:"Light",        color:"#3b82f6" };
  if (pct < 50) return { label:"Moderate",     color:"#854d0e" };
  return             { label:"Heavy",          color:"#991b1b" };
}

// ── Suitability section ──────────────────────────────────────────────────────
const VERDICT_CFG = {
  rainfed:      { bg:"#dcfce7", color:"#15803d", label:"Rainfed Viable" },
  supplemental: { bg:"#fef9c3", color:"#854d0e", label:"Supplemental Irrigation" },
  moderate:     { bg:"#ffedd5", color:"#9a3412", label:"Moderate Irrigation Required" },
  intensive:    { bg:"#fee2e2", color:"#991b1b", label:"Intensive Irrigation Required" },
  unknown:      { bg:"#f3f4f6", color:"#6b7280", label:"Unknown" },
};

function SuitabilityPanel({ coordinates, cropKey, compareCropKey, apiBase }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const cropName    = IRRIG_CROPS[cropKey]?.name || cropKey;
  const compareName = compareCropKey ? (IRRIG_CROPS[compareCropKey]?.name || compareCropKey) : null;

  // Backend _CROP_REQUIREMENTS now keys by display name directly — no mapping needed.
  const backendCrop    = cropName;
  const backendCompare = compareCropKey ? (IRRIG_CROPS[compareCropKey]?.name || compareName) : null;

  useEffect(() => {
    if (!coordinates || coordinates.length < 3) return;
    const lat = coordinates.reduce((s, c) => s + c[1], 0) / coordinates.length;
    const lon = coordinates.reduce((s, c) => s + c[0], 0) / coordinates.length;
    const ha  = (() => {
      const R = 6371000, toRad = d => d * Math.PI / 180;
      let area = 0; const n = coordinates.length;
      for (let i = 0; i < n; i++) {
        const [lo1, la1] = coordinates[i], [lo2, la2] = coordinates[(i+1)%n];
        area += toRad(lo2-lo1) * (2 + Math.sin(toRad(la1)) + Math.sin(toRad(la2)));
      }
      return Math.abs(area * R * R / 2) / 10000;
    })();
    setLoading(true); setErr(null);
    axios.post(`${apiBase}/irrigation-advanced`, {
      lat, lon, crop: backendCrop, compare_crop: backendCompare, field_ha: ha,
    }).then(r => { setData(r.data); setLoading(false); })
      .catch(e => { setErr(e.message); setLoading(false); });
  }, [coordinates, cropKey, compareCropKey]);

  if (loading) return <div style={{ color:"#7a9a6a", fontSize:12 }}>Loading suitability data…</div>;
  if (err) return <div style={{ color:"#c33", fontSize:12 }}>{err}</div>;
  if (!data) return null;

  const SuitCard = ({ suit, name }) => {
    if (!suit) return null;
    const cfg = VERDICT_CFG[suit.verdict] || VERDICT_CFG.unknown;
    return (
      <div style={{ background:cfg.bg, border:`1px solid ${cfg.color}30`, borderRadius:10, padding:"14px 16px", marginBottom:10 }}>
        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
          <span style={{ fontWeight:700, fontSize:13, color:cfg.color }}>{name}</span>
          <span style={{ fontSize:10, fontWeight:700, background:cfg.color+"20", color:cfg.color,
            padding:"2px 7px", borderRadius:10 }}>{cfg.label}</span>
        </div>
        <p style={{ fontSize:11, color:"#374151", margin:"0 0 8px", lineHeight:1.6 }}>{suit.description}</p>
        <div style={{ display:"flex", gap:16, fontSize:10, color:"#6b7280", flexWrap:"wrap" }}>
          <span>Annual rainfall: <strong>{suit.annual_precip_mm} mm</strong></span>
          <span>Seasonal ETc: <strong>{suit.etc_season_mm} mm</strong></span>
          <span>Deficit: <strong>{suit.annual_deficit_mm} mm ({suit.deficit_pct}%)</strong></span>
          <span>Crop water need: <strong>{suit.r_min}–{suit.r_max} mm/yr</strong></span>
        </div>
      </div>
    );
  };

  return (
    <div>
      <SuitCard suit={data.suitability} name={cropName} />
      {data.compare_suitability && <SuitCard suit={data.compare_suitability} name={compareName} />}
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────
// Map display crop names (from App.js CROPS array) to IRRIG_CROPS keys
function displayNameToIrrigKey(name) {
  if (!name) return "corn_maize";
  const lower = name.toLowerCase().trim();
  const direct = Object.keys(IRRIG_CROPS).find(k => k === lower);
  if (direct) return direct;
  const byName = Object.keys(IRRIG_CROPS).find(k =>
    IRRIG_CROPS[k].name.toLowerCase() === lower ||
    IRRIG_CROPS[k].name.toLowerCase().includes(lower) ||
    lower.includes(IRRIG_CROPS[k].name.toLowerCase().split(" ")[0].replace(/[()]/g,""))
  );
  return byName || "corn_maize";
}

export default function IrrigationCalc({ coordinates, apiBase, isPro, initialCrop }) {
  const [cropKey,      setCropKey]      = useState(() => displayNameToIrrigKey(initialCrop) || "corn_maize");
  const [compareCropKey, setCompareCropKey] = useState("");
  const [plantMonth0,  setPlantMonth0]  = useState(3);
  const [acreage,      setAcreage]      = useState(100);
  const [unit,         setUnit]         = useState("acre-in");
  const [scenario,     setScenario]     = useState("bau");
  const [climate,      setClimate]      = useState(null);
  const [loading,      setLoading]      = useState(false);
  const [error,        setError]        = useState(null);
  const [innerTab,     setInnerTab]     = useState("demand"); // demand | compare | schedule | suitability
  const [waterPriceM3, setWaterPriceM3] = useState(0.50); // $ per m³

  useEffect(() => {
    if (!coordinates || coordinates.length < 3) return;
    const R = 6371000, toRad = d => d * Math.PI / 180;
    let area = 0; const n = coordinates.length;
    for (let i = 0; i < n; i++) {
      const [lon1, lat1] = coordinates[i], [lon2, lat2] = coordinates[(i+1)%n];
      area += toRad(lon2-lon1) * (2 + Math.sin(toRad(lat1)) + Math.sin(toRad(lat2)));
    }
    const ha = Math.abs(area * R * R / 2) / 10000;
    setAcreage(Math.max(1, Math.round(ha * 2.47105)));
  }, [coordinates]);

  // Sync crop key when parent field tab crop changes
  useEffect(() => {
    if (!initialCrop) return;
    const k = displayNameToIrrigKey(initialCrop);
    if (k) setCropKey(k);
  }, [initialCrop]);

  useEffect(() => {
    if (!coordinates || !coordinates.length) return;
    const lat = coordinates.reduce((s, c) => s + c[1], 0) / coordinates.length;
    const crop = IRRIG_CROPS[cropKey];
    if (!crop) return;
    let mo = crop.plantMonthN - 1;
    if (lat < 0) mo = (mo + 6) % 12;
    setPlantMonth0(mo);
  }, [cropKey, coordinates]);

  useEffect(() => {
    if (!coordinates || coordinates.length < 3) { setClimate(null); return; }
    const lat = coordinates.reduce((s, c) => s + c[1], 0) / coordinates.length;
    const lon = coordinates.reduce((s, c) => s + c[0], 0) / coordinates.length;
    setLoading(true); setError(null);
    axios.post(`${apiBase}/irrigation-climate`, { lat, lon })
      .then(r => { setClimate(r.data); setLoading(false); })
      .catch(() => { setError("Could not load climate data"); setLoading(false); });
  }, [coordinates, apiBase]);

  const sc    = SCENARIOS.find(s => s.key === scenario) || SCENARIOS[0];
  const crop  = IRRIG_CROPS[cropKey];
  const cmpCrop = compareCropKey ? IRRIG_CROPS[compareCropKey] : null;
  const months    = climate ? calcMonthly(crop, climate, plantMonth0, sc.etoMult, 1 + sc.dPrecip) : [];
  const cmpMonths = (climate && cmpCrop)
    ? calcMonthly(cmpCrop, climate, plantMonth0, sc.etoMult, 1 + sc.dPrecip) : [];

  const totalBlueAI  = months.reduce((s, m) => s + m.blue  * acreage, 0);
  const totalGreenAI = months.reduce((s, m) => s + m.green * acreage, 0);
  const totalEtaAI   = months.reduce((s, m) => s + m.eta   * acreage, 0);
  const bluePct  = totalEtaAI > 0 ? (totalBlueAI  / totalEtaAI * 100).toFixed(1) : "–";
  const greenPct = totalEtaAI > 0 ? (totalGreenAI / totalEtaAI * 100).toFixed(1) : "–";
  const totalDays = crop.L.reduce((a, b) => a + b, 0);
  const seasonMos = Math.round(totalDays / 30.4);
  const disp = convert(totalBlueAI, unit);
  const acreHa = acreage / 2.47105;

  const catGroups = {};
  CAT_ORDER.forEach(cat => { catGroups[cat] = []; });
  Object.entries(IRRIG_CROPS).forEach(([k, c]) => {
    if (!catGroups[c.cat]) catGroups[c.cat] = [];
    catGroups[c.cat].push([k, c.name]);
  });

  const s = {
    root:    { padding: "0 0 32px", fontSize: 13, color: "#1a2e1a" },
    card:    { background: "#fff", borderRadius: 10, padding: "12px 14px", margin: "0 12px 10px", border: "1px solid #e2ead8", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" },
    label:   { fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#5a7a4a", marginBottom: 6 },
    select:  { width: "100%", padding: "8px 10px", fontSize: 13, borderRadius: 7, border: "1px solid #c8d8c0", background: "#f5f9f3", color: "#1a2e1a", fontFamily: "inherit" },
    row2:    { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 8, minWidth: 0 },
    hero:    { background: "linear-gradient(135deg,#1356A8,#2B7FDE)", color: "#fff", borderRadius: 10, padding: "16px 14px", margin: "0 12px 10px" },
    heroLbl: { fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", opacity: 0.65, marginBottom: 4 },
    heroBig: { fontFamily: "Georgia,serif", fontSize: 54, fontWeight: 400, lineHeight: 1, letterSpacing: "-0.03em" },
    heroSub: { fontSize: 11, opacity: 0.65, marginTop: 4 },
    pill:    { flex: 1, padding: "10px 12px", borderRadius: 8, textAlign: "center" },
    pillLbl: { fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", opacity: 0.7, marginBottom: 3 },
    pillVal: { fontFamily: "Georgia,serif", fontSize: 20 },
    pillPct: { fontSize: 10, opacity: 0.65, marginTop: 1 },
    scenRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 },
    scenNm:  { fontSize: 11, fontWeight: 600, minWidth: 70, color: "#1a2e1a" },
    scenTrk: { flex: 1, height: 7, background: "#eef2ea", borderRadius: 99, overflow: "hidden" },
    scenFil: { height: 7, borderRadius: 99, transition: "width 0.4s ease" },
    scenVal: { fontSize: 11, color: "#5a7a4a", minWidth: 80, textAlign: "right", fontVariantNumeric: "tabular-nums" },
    info:    { fontSize: 11, color: "#5a7a4a", background: "#f0f6ea", borderRadius: 7, padding: "8px 10px", margin: "0 12px 10px", lineHeight: 1.5 },
  };

  if (!coordinates || coordinates.length < 3) {
    return (
      <div style={s.root}>
        <div style={s.info}>
          Draw a field polygon on the map to load climate data and calculate irrigation demand.
        </div>
      </div>
    );
  }

  if (loading) return <div style={{ padding: "24px 16px", color: "#5a7a4a", fontSize: 13 }}>Loading climate data…</div>;
  if (error)   return <div style={{ padding: "16px", color: "#c0392b", fontSize: 13 }}>{error}</div>;
  if (!climate) return null;

  // ── inner tab bar ──
  const INNER_TABS = [
    { key:"demand",      label:"Demand",          pro:false },
    { key:"compare",     label:"Compare",         pro:true  },
    { key:"schedule",    label:"7-Day Schedule",  pro:false },
    { key:"suitability", label:"Suitability",     pro:true  },
  ].filter(t => isPro || !t.pro);

  return (
    <div style={s.root}>

      {/* Crop + planting (shared across tabs) */}
      <div style={s.card}>
        <div style={s.label}>Crop &amp; Planting</div>
        <select value={cropKey} onChange={e => setCropKey(e.target.value)} style={s.select}>
          {CAT_ORDER.filter(cat => catGroups[cat]?.length).map(cat => (
            <optgroup key={cat} label={cat}>
              {catGroups[cat].map(([k, name]) => <option key={k} value={k}>{name}</option>)}
            </optgroup>
          ))}
        </select>
        <div style={s.row2}>
          <div>
            <div style={{ ...s.label, marginTop: 8 }}>Planting month</div>
            <select value={plantMonth0} onChange={e => setPlantMonth0(+e.target.value)} style={s.select}>
              {MONTH_NAMES.map((m, i) => <option key={i} value={i}>{m}</option>)}
            </select>
          </div>
          <div>
            <div style={{ ...s.label, marginTop: 8 }}>Acreage</div>
            <input type="number" value={acreage} min={1} onChange={e => setAcreage(Math.max(1, +e.target.value))}
              style={{ ...s.select, padding: "7px 10px", width: "100%", minWidth: 0, boxSizing: "border-box" }} />
          </div>
        </div>
      </div>

      {/* Inner tab bar */}
      <div style={{ display:"flex", gap:2, padding:"0 12px 10px", borderBottom:"1px solid #e2ead8", marginBottom:4 }}>
        {INNER_TABS.map(t => (
          <button key={t.key} onClick={() => setInnerTab(t.key)} style={{
            padding:"6px 12px", fontSize:11, fontWeight:600, borderRadius:6, cursor:"pointer",
            background: innerTab === t.key ? "#2d5a1b" : "#f0f6ea",
            color:       innerTab === t.key ? "#fff"    : "#2d5a1b",
            border:"1px solid " + (innerTab === t.key ? "#2d5a1b" : "#dde8d0"),
          }}>{t.label}</button>
        ))}
      </div>

      {/* ── Demand tab (original content) ── */}
      {innerTab === "demand" && (<>
        <div style={{ ...s.card, marginTop:8 }}>
          <div style={s.label}>Climate scenario</div>
          <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
            {SCENARIOS.map(sc2 => (
              <button key={sc2.key} onClick={() => setScenario(sc2.key)} style={{
                padding: "4px 10px", fontSize: 11, fontWeight: 600, borderRadius: 20,
                border: scenario === sc2.key ? `2px solid ${sc2.color}` : "1px solid #ddd",
                background: scenario === sc2.key ? sc2.color + "22" : "#fff",
                color: scenario === sc2.key ? sc2.color : "#666", cursor: "pointer",
              }}>{sc2.name}</button>
            ))}
          </div>
        </div>

        <div style={s.hero}>
          <div style={s.heroLbl}>Seasonal irrigation demand</div>
          <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 6 }}>
            <div style={s.heroBig}>{disp.val}</div>
            <select value={unit} onChange={e => setUnit(e.target.value)}
              style={{ background: "rgba(255,255,255,0.2)", border: "1px solid rgba(255,255,255,0.35)", color: "#fff", borderRadius: 6, padding: "5px 8px", fontSize: 12, fontFamily: "inherit" }}>
              {[["acre-in","acre-in"],["acre-ft","acre-ft"],["m3","m³"],["mm","mm/season"],["gal","k·gal"]].map(([v,l]) =>
                <option key={v} value={v} style={{ background: "#1a3a5c", color:"#fff" }}>{l}</option>
              )}
            </select>
          </div>
          <div style={s.heroSub}>
            {acreage} acres · {crop.name} · {seasonMos}-month season
            {sc.key !== "bau" && ` · ${sc.name} (+${sc.dTemp}°C)`}
          </div>
        </div>

        <div style={{ display: "flex", gap: 0, padding: "0 12px 10px" }}>
          <div style={{ ...s.pill, background: "#EBF3FB" }}>
            <div style={{ ...s.pillLbl, color: "#1356A8" }}>Blue water (irrigation)</div>
            <div style={{ ...s.pillVal, color: "#1356A8" }}>{convert(totalBlueAI, unit).val}</div>
            <div style={{ ...s.pillPct, color: "#1356A8" }}>{bluePct}% of ETa</div>
          </div>
          <div style={{ ...s.pill, background: "#EBF5E4", marginLeft: 8 }}>
            <div style={{ ...s.pillLbl, color: "#2d6b1a" }}>Green water (rain)</div>
            <div style={{ ...s.pillVal, color: "#2d6b1a" }}>{convert(totalGreenAI, unit).val}</div>
            <div style={{ ...s.pillPct, color: "#2d6b1a" }}>{greenPct}% of ETa</div>
          </div>
        </div>

        <div style={s.card}>
          <div style={s.label}>Monthly crop water need vs rainfall (in/month per acre)</div>
          <MonthlyChart months={months} acreage={acreage} />
        </div>

        <div style={s.card}>
          <div style={s.label}>Crop coefficient (Kc) by growth stage — FAO-56</div>
          <div style={{ display: "flex", gap: 6 }}>
            {[["Initial", crop.kc[0], "#a0c080"], ["Mid-season", crop.kc[1], "#2d8a1b"], ["Late-season", crop.kc[2], "#7aab5a"]].map(([lbl, val, col]) => (
              <div key={lbl} style={{ flex: 1, background: "#f5f9f3", borderRadius: 7, padding: "8px", textAlign: "center" }}>
                <div style={{ fontSize: 9, color: "#888", textTransform: "uppercase", letterSpacing: "0.06em" }}>{lbl}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: col }}>{val.toFixed(2)}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize: 10, color: "#999", marginTop: 8 }}>
            Season length: {crop.L[0]}d init · {crop.L[1]}d dev · {crop.L[2]}d mid · {crop.L[3]}d late = {totalDays}d total
          </div>
        </div>

        <div style={s.card}>
          <div style={s.label}>Climate scenario comparison</div>
          {(() => {
            const demands = SCENARIOS.map(sc2 => {
              const ms2 = calcMonthly(crop, climate, plantMonth0, sc2.etoMult, 1 + sc2.dPrecip);
              return ms2.reduce((s, m) => s + m.blue * acreage, 0);
            });
            const maxD = Math.max(...demands, 0.1), baseD = demands[0];
            return SCENARIOS.map((sc2, i) => {
              const pct  = (demands[i] / maxD * 100).toFixed(1);
              const diff = demands[i] - baseD;
              const diffPct = baseD > 0 ? `${diff>=0?"+":""}${((diff/baseD)*100).toFixed(0)}%` : "";
              return (
                <div key={sc2.key} style={s.scenRow}>
                  <div style={s.scenNm}>{sc2.name}</div>
                  <div style={s.scenTrk}><div style={{ ...s.scenFil, width:`${pct}%`, background:sc2.color }} /></div>
                  <div style={s.scenVal}>{convert(demands[i], unit).val} <span style={{ fontSize:10, color: diff>0?"#c0392b":diff<0?"#2d8a1b":"#999" }}>{i > 0 ? diffPct : ""}</span></div>
                </div>
              );
            });
          })()}
        </div>

        {/* Water Cost Calculator */}
        {totalEtaAI > 0 && (() => {
          // Convert totalBlueAI (acre-in) to m³: 1 acre-in = 102.79 m³
          const totalM3 = totalBlueAI * 102.79;
          const seasonCost = totalM3 * waterPriceM3;
          const costPerHa = acreage > 0 ? (seasonCost / (acreage * 0.4047)) : 0;
          // Efficiency comparison: drip vs flood
          const floodM3 = totalM3 / 0.60;  // flood ~60% efficiency
          const dripM3  = totalM3 / 0.90;  // drip  ~90% efficiency
          return (
            <div style={s.card}>
              <div style={{ fontSize:11, fontWeight:700, color:"#1356A8", marginBottom:8, textTransform:"uppercase", letterSpacing:"0.06em" }}>
                Water Cost Calculator
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
                <label style={{ fontSize:11, color:"#666", flexShrink:0 }}>Water price ($/m³):</label>
                <input type="number" min="0.01" step="0.05" value={waterPriceM3}
                  onChange={e => setWaterPriceM3(parseFloat(e.target.value)||0.50)}
                  style={{ width:70, padding:"3px 6px", border:"1px solid #ccc", borderRadius:5, fontSize:12 }} />
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:10 }}>
                <div style={{ textAlign:"center", background:"#EBF3FB", borderRadius:8, padding:8 }}>
                  <div style={{ fontSize:18, fontWeight:700, color:"#1356A8" }}>{Math.round(totalM3).toLocaleString()}</div>
                  <div style={{ fontSize:9, color:"#1356A8" }}>m³ needed</div>
                </div>
                <div style={{ textAlign:"center", background:"#e8f5e9", borderRadius:8, padding:8 }}>
                  <div style={{ fontSize:18, fontWeight:700, color:"#2e7d32" }}>${Math.round(seasonCost).toLocaleString()}</div>
                  <div style={{ fontSize:9, color:"#2e7d32" }}>season cost</div>
                </div>
                <div style={{ textAlign:"center", background:"#fafaf8", borderRadius:8, padding:8 }}>
                  <div style={{ fontSize:18, fontWeight:700, color:"#555" }}>${Math.round(costPerHa).toLocaleString()}</div>
                  <div style={{ fontSize:9, color:"#888" }}>per hectare</div>
                </div>
              </div>
              <div style={{ fontSize:10, color:"#666", marginBottom:4, fontWeight:600 }}>Irrigation efficiency comparison</div>
              {[["Flood / furrow", floodM3, "#c0392b", "60%"],
                ["Sprinkler", totalM3 / 0.75, "#e67e22", "75%"],
                ["Drip / micro", dripM3, "#27ae60", "90%"]].map(([name, m3, col, eff]) => (
                <div key={name} style={{ display:"flex", justifyContent:"space-between", fontSize:10, color:"#666", marginBottom:3, alignItems:"center" }}>
                  <span style={{ width:110 }}>{name} ({eff})</span>
                  <span style={{ flex:1, height:5, background:"#eee", borderRadius:3, margin:"0 8px", overflow:"hidden" }}>
                    <div style={{ height:"100%", background:col, width:`${Math.min(100, m3/floodM3*100)}%`, borderRadius:3 }}/>
                  </span>
                  <span style={{ color:col, fontWeight:600, width:60, textAlign:"right" }}>
                    ${Math.round(m3 * waterPriceM3).toLocaleString()}
                  </span>
                </div>
              ))}
            </div>
          );
        })()}

        <div style={{ ...s.info, fontFamily: "monospace", fontSize: 11 }}>
          ETa = ETo(NASA POWER) × Kc(FAO-56) · Blue = max(0, ETa − Precip) · Green = min(ETa, Precip){"\n"}
          ETo computed via Hargreaves-Samani from 30-yr climatological normals
        </div>
      </>)}

      {/* ── Compare tab ── */}
      {innerTab === "compare" && (() => {
        const ranked = rankCropsByLocation(climate, plantMonth0, cropKey);
        const topPicks = ranked.slice(0, 8);
        return (
        <div style={{ ...s.card, marginTop:8 }}>

          {/* Recommended crops */}
          <div style={{ marginBottom:16 }}>
            <div style={{ ...s.label, marginBottom:8 }}>Lowest irrigation demand at this location</div>
            <div style={{ fontSize:11, color:"#7a9a6a", marginBottom:10, lineHeight:1.5 }}>
              Crops climatically suited to {climate?.ann_temp_c != null ? `${climate.ann_temp_c}°C avg temp` : "this location"},
              ranked by how much supplemental water they need. Crops outside their viable temperature range are excluded.
              Click any crop to compare it against {crop.name}.
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
              {topPicks.map(({ key: k, crop: c, blue, eta, green, rainPct }, rank) => {
                const lbl   = irrigLabel(blue, eta);
                const rainMm = +(green * 25.4).toFixed(0);
                const irrMm  = +(blue  * 25.4).toFixed(0);
                const isSelected = compareCropKey === k;
                return (
                  <button key={k} onClick={() => setCompareCropKey(k)}
                    style={{
                      display:"flex", alignItems:"center", gap:10, padding:"8px 10px",
                      borderRadius:8, border: isSelected ? "2px solid #2d5a1b" : "1px solid #e2ead8",
                      background: isSelected ? "#f0f6ea" : "#fff",
                      cursor:"pointer", textAlign:"left",
                    }}>
                    <div style={{ fontSize:11, fontWeight:700, color:"#aaa", width:16, flexShrink:0 }}>
                      {rank + 1}
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:12, fontWeight:700, color:"#1a2e1a" }}>{c.name}</div>
                      <div style={{ fontSize:10, color:"#7a9a6a", marginTop:1 }}>
                        {rainMm > 0 ? `${rainMm} mm rain-fed` : "No rain coverage"}
                        {irrMm > 0 ? ` · ${irrMm} mm irrigation` : ""}
                        {" · "}{rainPct.toFixed(0)}% from rain
                      </div>
                    </div>
                    <div style={{ fontSize:10, fontWeight:700, background: lbl.color + "18",
                      color: lbl.color, padding:"2px 8px", borderRadius:10, flexShrink:0 }}>
                      {lbl.label}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          <div style={{ borderTop:"1px solid #f0f0e8", paddingTop:12 }}>
            <div style={s.label}>Or pick any crop manually</div>
            <select value={compareCropKey} onChange={e => setCompareCropKey(e.target.value)} style={{ ...s.select, marginBottom:12 }}>
              <option value="">— select a crop to compare —</option>
              {CAT_ORDER.filter(cat => catGroups[cat]?.length).map(cat => (
                <optgroup key={cat} label={cat}>
                  {catGroups[cat].filter(([k]) => k !== cropKey).map(([k, name]) => <option key={k} value={k}>{name}</option>)}
                </optgroup>
              ))}
            </select>
          </div>

          {!compareCropKey && (
            <div style={{ color:"#999", fontSize:12 }}>Select a crop above to see side-by-side monthly water demand.</div>
          )}

          {compareCropKey && cmpCrop && (
            <>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
                  <thead>
                    <tr style={{ background:"#f0f6ea" }}>
                      <th style={{ padding:"6px 8px", textAlign:"left", fontWeight:700, fontSize:10, color:"#374151", borderBottom:"1px solid #e2ead8" }}>Month</th>
                      <th style={{ padding:"6px 8px", textAlign:"right", fontWeight:700, fontSize:10, color:"#374151", borderBottom:"1px solid #e2ead8" }}>Rain</th>
                      <th style={{ padding:"6px 8px", textAlign:"right", fontWeight:700, fontSize:10, color:"#2d5a1b", borderBottom:"1px solid #e2ead8" }}>{crop.name} ETa</th>
                      <th style={{ padding:"6px 8px", textAlign:"right", fontWeight:700, fontSize:10, color:"#2d5a1b", borderBottom:"1px solid #e2ead8" }}>{crop.name} Need</th>
                      <th style={{ padding:"6px 8px", textAlign:"right", fontWeight:700, fontSize:10, color:"#7c3aed", borderBottom:"1px solid #e2ead8" }}>{cmpCrop.name} ETa</th>
                      <th style={{ padding:"6px 8px", textAlign:"right", fontWeight:700, fontSize:10, color:"#7c3aed", borderBottom:"1px solid #e2ead8" }}>{cmpCrop.name} Need</th>
                      <th style={{ padding:"6px 8px", textAlign:"right", fontWeight:700, fontSize:10, color:"#374151", borderBottom:"1px solid #e2ead8" }}>Diff</th>
                    </tr>
                  </thead>
                  <tbody>
                    {months.map((mo, i) => {
                      const cmo = cmpMonths[i];
                      const diff = cmo ? +(cmo.blue - mo.blue).toFixed(2) : null;
                      const precip_in = (climate.precip[mo.mo] || 0);
                      const precip_mm = +(precip_in * 25.4).toFixed(0);
                      return (
                        <tr key={mo.mo} style={{ borderBottom:"1px solid #f0f0f0" }}>
                          <td style={{ padding:"5px 8px", fontWeight:600, color:"#1a2e1a" }}>{mo.name}</td>
                          <td style={{ padding:"5px 8px", textAlign:"right", color:"#2563eb" }}>{precip_mm} mm</td>
                          <td style={{ padding:"5px 8px", textAlign:"right", color:"#2d5a1b" }}>{+(mo.eta*25.4).toFixed(0)} mm</td>
                          <NetCell mm={+(mo.blue*25.4).toFixed(0)} />
                          {cmo ? <>
                            <td style={{ padding:"5px 8px", textAlign:"right", color:"#7c3aed" }}>{+(cmo.eta*25.4).toFixed(0)} mm</td>
                            <NetCell mm={+(cmo.blue*25.4).toFixed(0)} />
                            <td style={{ padding:"5px 8px", textAlign:"right", fontSize:11, fontWeight:600,
                              color: diff > 0 ? "#991b1b" : diff < 0 ? "#15803d" : "#999" }}>
                              {diff === 0 ? "—" : `${diff > 0 ? "+" : ""}${+(diff*25.4).toFixed(0)} mm`}
                            </td>
                          </> : <td colSpan={3} style={{ color:"#aaa", fontSize:11, padding:"5px 8px" }}>—</td>}
                        </tr>
                      );
                    })}
                    {/* Totals */}
                    <tr style={{ background:"#f0f6ea", fontWeight:700 }}>
                      <td style={{ padding:"6px 8px", fontSize:11 }}>Total</td>
                      <td></td>
                      <td style={{ padding:"6px 8px", textAlign:"right", color:"#2d5a1b", fontSize:11 }}>
                        {months.reduce((s,m) => s + +(m.eta*25.4).toFixed(0), 0)} mm
                      </td>
                      <td style={{ padding:"6px 8px", textAlign:"right", color:"#991b1b", fontSize:11 }}>
                        {months.reduce((s,m) => s + +(m.blue*25.4).toFixed(0), 0)} mm
                      </td>
                      {cmpMonths.length > 0 ? <>
                        <td style={{ padding:"6px 8px", textAlign:"right", color:"#7c3aed", fontSize:11 }}>
                          {cmpMonths.reduce((s,m) => s + +(m.eta*25.4).toFixed(0), 0)} mm
                        </td>
                        <td style={{ padding:"6px 8px", textAlign:"right", color:"#991b1b", fontSize:11 }}>
                          {cmpMonths.reduce((s,m) => s + +(m.blue*25.4).toFixed(0), 0)} mm
                        </td>
                        <td style={{ padding:"6px 8px", textAlign:"right", fontSize:11, fontWeight:700,
                          color: cmpMonths.reduce((s,m)=>s+m.blue,0) > months.reduce((s,m)=>s+m.blue,0) ? "#991b1b":"#15803d" }}>
                          {(() => {
                            const d = cmpMonths.reduce((s,m)=>s+m.blue,0) - months.reduce((s,m)=>s+m.blue,0);
                            return `${d>=0?"+":""}${+(d*25.4).toFixed(0)} mm`;
                          })()}
                        </td>
                      </> : <td colSpan={3}></td>}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ fontSize:10, color:"#aaa", marginTop:8 }}>
                All values in mm/season. Negative diff = comparison crop uses less water.
              </div>
            </>
          )}
        </div>
        );
      })()}

      {/* ── 7-Day Schedule tab ── */}
      {innerTab === "schedule" && (
        <div style={{ ...s.card, marginTop:8 }}>
          <div style={{ ...s.label, marginBottom:10 }}>7-Day Forecast-Based Schedule — {crop.name}</div>
          <ForecastSchedule coordinates={coordinates} cropKcMid={crop.kc[1]} acreHa={acreHa} />
        </div>
      )}

      {/* ── Suitability tab ── */}
      {innerTab === "suitability" && (
        <div style={{ ...s.card, marginTop:8 }}>
          <div style={{ ...s.label, marginBottom:10 }}>Crop Irrigation Suitability for This Location</div>
          {compareCropKey && (
            <div style={{ fontSize:11, color:"#7a9a6a", marginBottom:10 }}>
              Comparing against: <strong>{IRRIG_CROPS[compareCropKey]?.name}</strong> (set in Compare tab)
            </div>
          )}
          <SuitabilityPanel
            coordinates={coordinates}
            cropKey={cropKey}
            compareCropKey={compareCropKey}
            apiBase={apiBase}
          />
        </div>
      )}

    </div>
  );
}
